import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import { useAcceptIncentiveOfferModal } from '../context/AcceptIncentiveOfferModalContext';

import AcceptIncentiveOfferModalStep1 from './AcceptIncentiveOfferModalStep1';
import AcceptIncentiveOfferModalStep2 from './AcceptIncentiveOfferModalStep2';
import AcceptIncentiveOfferModalStep3 from './AcceptIncentiveOfferModalStep3';

const getStepLiClassName = (stepNumber: number, currentStep: number) => {
  if (stepNumber === currentStep) return 'current';
  if (stepNumber < currentStep) return 'done';
  return '';
};

const AcceptIncentiveOfferModalBody: FC = () => {
  const { t } = useTranslate();
  const { data } = useAcceptIncentiveOfferModal();

  return (
    <Modal.Body className="py-4">
      <ul className="nk-stepper-nav nav nav-tabs nav-tabs-s2 accept-trading-offer-stepper mb-4 list-unstyled d-flex w-100">
        <li
          className={`${getStepLiClassName(1, data.currentStep)} flex-grow-1`}
          data-step="1"
        >
          <span className="step-item">
            <span className="step-text">{t('Summary')}</span>
          </span>
        </li>
        <li
          className={`${getStepLiClassName(2, data.currentStep)} flex-grow-1`}
          data-step="2"
        >
          <span className="step-item">
            <span className="step-text">{t('Verification')}</span>
          </span>
        </li>
        <li
          className={`${getStepLiClassName(3, data.currentStep)} flex-grow-1`}
          data-step="3"
        >
          <span className="step-item">
            <span className="step-text">{t('Confirmation')}</span>
          </span>
        </li>
      </ul>

      <div className="nk-stepper-content">
        <div className="nk-stepper-steps stepper-steps">
          {data.currentStep === 1 && <AcceptIncentiveOfferModalStep1 />}
          {data.currentStep === 2 && <AcceptIncentiveOfferModalStep2 />}
          {data.currentStep === 3 && <AcceptIncentiveOfferModalStep3 />}
        </div>
      </div>
    </Modal.Body>
  );
};

export default AcceptIncentiveOfferModalBody;
